"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _myDatePicker = _interopRequireDefault(require("@/components/myDatePicker"));
var _finance = require("@/api/finance");
var _merchant = require("@/api/merchant");
var _default = {
  components: {
    customPage: _customPage.default,
    myDatePicker: _myDatePicker.default
  },
  data: function data() {
    return {
      loading: true,
      searchForm: {
        orderNo: '',
        goodsName: '',
        status: -1,
        receivingName: '',
        receivingMobile: '',
        orderStatus: '',
        leaseTerm: '',
        orderCreateTime: '',
        leaseTime: '',
        orderPayTime: '',
        refundTime: '',
        datype: ''
      },
      statusList: [{
        id: -1,
        name: '全部'
      }, {
        id: 0,
        name: '未支付'
      }, {
        id: 1,
        name: '已支付'
      }, {
        id: 2,
        name: '已退款'
      }, {
        id: 4,
        name: '已逾期'
      }, {
        id: 5,
        name: '线下还款'
      }, {
        id: 6,
        name: '申请代扣'
      }, {
        id: 7,
        name: '拒绝代扣'
      }, {
        id: 8,
        name: '代扣失败'
      }],
      tableData: [],
      total: 0,
      selectList: [],
      merchantList: [],
      datedata: {
        today_pay: '-',
        today_no_pay: '-',
        tomorrow_all: '-'
      },
      merchantId: []
    };
  },
  mounted: function mounted() {
    this.getSelect();
    this.getList();
    this.getMerchantList();
    this.getBillPayDayData();
  },
  methods: {
    goToOrder: function goToOrder(orderId) {
      if (orderId) {
        // console.log(this.$router.resolve({ path:'/order/list?orderId='+orderId}))
        this.$func.openWindow('/order/list?orderId=' + orderId);
        // this.$router.push({ name: 'orderList', params: { orderId } });
      }
    },
    // 获取数据
    getList: function getList() {
      var _this = this;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      (0, _finance.financeLeaseList)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        _this.tableData = res.data || [];
        _this.total = res.total || 0;
      });
    },
    // 查询
    search: function search() {
      var pickerVal1 = this.$refs.makeOrderPicker.getVal();
      var pickerVal2 = this.$refs.withholdPicker.getVal();
      var pickerVal3 = this.$refs.payPicker.getVal();
      var pickerVal4 = this.$refs.refundPicker.getVal();
      if (pickerVal1 == 'error' || pickerVal2 == 'error' || pickerVal3 == 'error' || pickerVal4 == 'error') {
        return;
      }
      this.searchForm.orderCreateTime = pickerVal1;
      this.searchForm.leaseTime = pickerVal2;
      this.searchForm.orderPayTime = pickerVal3;
      this.searchForm.refundTime = pickerVal4;
      this.$refs.customPage.page = 1;
      this.getList();
      this.getBillPayDayData();
    },
    // 重置
    reset: function reset() {
      if (this.$refs.makeOrderPicker) {
        this.$refs.makeOrderPicker.reset();
      }
      if (this.$refs.withholdPicker) {
        this.$refs.withholdPicker.reset();
      }
      if (this.$refs.payPicker) {
        this.$refs.payPicker.reset();
      }
      if (this.$refs.refundPicker) {
        this.$refs.refundPicker.reset();
      }
      this.searchForm = {
        orderNo: '',
        goodsName: '',
        receivingName: '',
        receivingMobile: '',
        orderStatus: '',
        leaseTerm: '',
        orderCreateTime: '',
        leaseTime: '',
        orderPayTime: '',
        refundTime: ''
      };
      this.getList();
    },
    // 导出
    exportFile: function exportFile() {
      (0, _finance.leaseListExport)(this.searchForm);
    },
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, _this$merchantList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  (_this$merchantList = this.merchantList).push.apply(_this$merchantList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    merchantIdChangeString: function merchantIdChangeString(val) {
      this.searchForm.merchantId = val.join(',');
    },
    getSelect: function getSelect() {
      var _this2 = this;
      (0, _finance.getOrderStatus)().then(function (res) {
        var list = [];
        for (var key in res) {
          list.push({
            id: key,
            name: res[key]
          });
        }
        _this2.selectList = list || [];
      });
    },
    getLeaseStatusType: function getLeaseStatusType(status) {
      var listtype = {
        0: "未支付",
        1: "已支付",
        2: "已退款",
        3: "已买断",
        4: "已逾期",
        5: "线下支付",
        6: "发起代扣",
        7: "代扣被拒",
        8: "代扣失败"
      };
      return listtype[status];
    },
    getBillPayDayData: function getBillPayDayData() {
      var _this3 = this;
      (0, _finance.getOrderBillPayDayData)({
        merchantId: this.searchForm.merchantId
      }).then(function (res) {
        var data = (0, _objectSpread2.default)({}, res);
        _this3.datedata = data || [];
      });
    },
    todayPay: function todayPay(type) {
      this.searchForm.datype = type;
      this.getList();
    }
  }
};
exports.default = _default;